/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2020-11-06 20:40:06
 * @LastEditors: voanit
 * @LastEditTime: 2021-12-29 15:31:42
 */
import axios from 'axios'
import Qs from 'qs'
import { setMyToken, getMyToken, getUnify, removeUnify } from '@/utils/auth'
import { MessageBox, Message } from 'element-ui'

export default function ajax(options) {
  const unify = getUnify()
  let token = ''
  if (unify) {
    token = unify
  }

  const promise = new Promise((resolve, reject) => {
    const service = axios.create({
      baseURL: process.env.VUE_APP_BASE_API,
      method: 'GET',
      headers: {
        authorization: token,
        clientType: 1
      },
      data: options.option.data,
      timeout: 60000,
      responseType: 'string'
    })

    service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
    service.interceptors.request.use(
      config => {
        if (config.method === 'get') {
          config.params = { ...config.data }
        }
        if (config.data == undefined) {
          return config
        }
        return config
      },
      function(err) {
        return Promise.reject(err)
      }
    )
    service.interceptors.response.use(
      response => {
        const data = JSON.stringify(response.data)
        let newData = new Function('return ' + data)()
        if (typeof newData == 'string') {
          newData = newData
            .replace(/status/, '"status"')
            .replace(/message/, '"message"')
            .replace(/data/, '"data"')
          newData = JSON.parse(newData)
        }
        if (newData.code === 2003) {
          Message({
            message: newData.message || 'Error',
            type: 'error',
            duration: 2000
          })
          removeUnify()
          window.location.reload()
        }
        return newData
      },
      function(err) {
        console.log('请求错误', err)
        return Promise.reject(err)
        // console.log("异常 关闭Loading图标")
      }
    )
    service(options)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        console.log(err, 'err')
        reject(err)
      })
  })
  return promise
    .then(res => {
      options.option.success(res)
    })
    .catch(err => {
      console.log(err)
      options.option.error && options.option.error(err)
    })
}
